import { createLazyModal } from "../shared/Modal/LazyModal";

export const DeleteJobModal = createLazyModal(() =>
  import("@/pages/Jobs/DeleteModal")
);
export const TemplateModal = createLazyModal(() =>
  import("@/components/Templates/TemplateModal")
);
export const CreateInvoiceModal = createLazyModal(() =>
  import("@/modals/CreateInvoiceModal")
);
export const SendPDFModal = createLazyModal(() =>
  import("@/modals/SendPdfModal")
);
export const JobActionModal = createLazyModal(() =>
  import("@/modals/JobActionModal")
);
export const JobApproveModal = createLazyModal(() =>
  import("@/modals/JobApproveModal")
);
export const SummaryModal = createLazyModal(() =>
  import("@/modals/SummaryModal")
);
export const LocationCreateModal = createLazyModal(() =>
  import("@/modals/LocationCreateModal")
);
export const DispatchEventModal = createLazyModal(() =>
  import("@/modals/DispatchEventModal")
);
export const AssignResourcesModal = createLazyModal(() =>
  import("@/modals/AssignResourcesModal")
);
export const DispatchJobModal = createLazyModal(() =>
  import("@/modals/DispatchJobModal")
);
export const ScheduleJobModal = createLazyModal(() =>
  import("@/modals/ScheduleJobModal")
);
export const CompleteJobModal = createLazyModal(() =>
  import("@/modals/CompleteJobModal")
);
export const ConfirmResetModal = createLazyModal(() =>
  import("@/modals/ConfirmResetModal")
);
export const LegRouteModal = createLazyModal(() =>
  import("@/modals/LegRouteModal")
);

// Universal Create Button Modals
export const JobCreateModal = createLazyModal(() =>
  import("@/pages/Jobs/CreateModal")
);
export const InvoiceCreateModal = createLazyModal(() =>
  import("@/pages/Invoices/CreateModal")
);
export const ManifestCreateModal = createLazyModal(() =>
  import("@/pages/Manifests/CreateModal")
);
export const PayoutCreateModal = createLazyModal(() =>
  import("@/pages/Payouts/CreateModal")
);
export const ClientCreateModal = createLazyModal(() =>
  import("@/pages/Clients/CreateModal").then((module) => ({
    default: module.CreateClientModal,
  }))
);
export const DriverCreateModal = createLazyModal(() =>
  import("@/pages/Drivers/DriverCreateModal")
);
export const UserCreateModal = createLazyModal(() =>
  import("@/modals/UserCreateModal")
);
